"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// CONSTANTS
var _default = exports["default"] = {
  heightSizeTypeId: 1,
  widthSizeTypeId: 2,
  defaultMinValue: 6,
  defaultMaxValue: 192,
  threeColumnLeftId: 3451,
  threeColumnMidId: 3452,
  threeColumnRightId: 3453,
  twoColumnLeftId: 3430,
  twoColumnRightId: 3429
};
//# sourceMappingURL=constants.js.map